import * as THREE from "three";

const cube = (obj, ctxt, cube) => {
    let {camera, scene} = obj;

    scene.add( cube );
    camera.position.z = 5;
};

const addToScene = (obj, ctxt, mesh) => {
    let {camera, scene} = obj;

    scene.add(mesh);
    camera.position.z = 3;
};

let lastRenderTime = undefined;
let fpsList = [];

const average = (list) => {
    let c = 0;
    let sum = 0;
    for (let i=0; i < 20; i++) {
        if (list[i]) {
            sum+=list[i];
            c++;
        }
    }
    return sum/c;
};
const render = (obj, ctxt, scene, camera) => {
    // forces a draw
    let time = new Date().getTime();
    if (lastRenderTime) {
        let ms = time - lastRenderTime;
        let fps = 1000/ms;
        fpsList.unshift(fps);
        window.fps = average(fpsList);
    }
    lastRenderTime = time;
    let a = window.errors.length;
    let {renderer} = obj;
    renderer.render(scene, camera);
    let b = window.errors.length;
    if (b-a > 0) {
        let errors = window.errors.splice(a+1);
        return errors;
    }
};

const draw = (obj, ctxt) => {
    // forces a draw
};

const camera = (obj, ctxt, x,y,z) => {
    let {camera} = obj;
    camera.position.x = x;
    camera.position.y = y;
    camera.position.z = z;
};

const autoClear = (obj, ctxt, o) => {
    obj.renderer.autoClear = false;
};

const clear = (obj) => {
    obj.renderer.clear();
};


export const core = {
    clear,
    addToScene,
    cube,
    camera,
    draw,
    render,
    autoClear
};
